import styles from './SimpleArrowAccordionV2.scss';

import cx from 'classnames';
import React from 'react';

import { Icon, IconType } from 'src/components/Icon/Icon';
import { Accordion } from '../Accordion';
import { AccordionItem, AccordionItemId, OpenSections } from '../models';

interface SimpleArrowAccordionV2Props {
  items: AccordionItem[];
  allowMultipleOpen?: boolean;
  alwaysHaveOneItemOpen?: boolean;
  className?: string;
  bodyClassName?: string;
}

export const getAccordionRowsJSX = (items: AccordionItem[], onToggled: (id: AccordionItemId) => void, openSections: OpenSections, bodyClassName?: string) => {
  return items.map((item, index) => (
    <React.Fragment key={item.id}>
      <Accordion.Header
        defaultOpen={item.defaultOpen}
        itemId={index}
        onToggled={onToggled}
        openSections={openSections}
        className={cx(item.headerClassName, styles.header)}
      >
        <span>{item.title}</span>
        <Icon type={openSections[index] ? IconType.CHEVRON_UP : IconType.CHEVRON_DOWN} className={cx({ [styles.chevronUpIcon]: openSections[index] })} />
      </Accordion.Header>
      <Accordion.Body itemId={index} openSections={openSections} className={cx(styles.body, bodyClassName)} animationModifier={1.6}>
        {item.body}
      </Accordion.Body>
    </React.Fragment>
  ));
};

export const SimpleArrowAccordionV2: React.FC<SimpleArrowAccordionV2Props> = props => {
  const { className, allowMultipleOpen , items, alwaysHaveOneItemOpen, bodyClassName } = props;

  return (
    <Accordion
      allowMultipleOpen={Boolean(allowMultipleOpen)}
      className={cx(styles.simpleArrowAccordion, className)}
      alwaysHaveOneItemOpen={alwaysHaveOneItemOpen}
    >
      {(onToggled, openSections) => (
        getAccordionRowsJSX(items, onToggled, openSections, bodyClassName)
      )}
    </Accordion>
  );
};
